import { render } from "./company-credential.vue?vue&type=template&id=e6666a52&scoped=true"
import script from "./company-credential.vue?vue&type=script&lang=js"
export * from "./company-credential.vue?vue&type=script&lang=js"

import "./company-credential.vue?vue&type=style&index=0&id=e6666a52&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6666a52"]])

export default __exports__